<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-help</v-icon>
        <v-toolbar-title>Statement Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.stmtType }}</td>
                  <td class="text-xs-left">{{ row.item.stmtTypeDesc }}</td>
                  <td class="text-xs-left">{{ row.item.dateType }}</td>
                  <td class="text-xs-left">{{ row.item.debtType }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
// import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      stmtType: 'stmtType',
      headers: [
        { text: 'Statement Type', value: 'stmtType' },
        { text: 'Statement Type Description', value: 'stmtTypeDesc' },
        { text: 'Date Type', value: 'dateType' },
        { text: 'Debtor Type', value: 'debtType' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      labels: {
        stmtType: 'Statement Type',
        stmtTypeDesc: 'Statement Type Description',
        dateType: 'Date Type',
        debtType: 'Debtor Type'
      },
      filters: {
        stmtType: undefined,
        stmtTypeDesc: undefined
      },
      loading: false,
      selectedStmtType: undefined,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getStmtTypeListByDebtTypeS
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result) {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((stmtType) => {
                const convertList = {
                  stmtType: stmtType.stmtType,
                  stmtTypeDesc: stmtType.stmtTypeDesc,
                  dateType: stmtType.dateType,
                  debtType: stmtType.debtType
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      const stmtTypeObj = {
        stmtType: data.stmtType,
        stmtTypeDesc: data.stmtTypeDesc
      }
      this.$emit('selectStmtType', stmtTypeObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.stmtType.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
